<ng-container >
  <ion-row class="topRow" [style.color]="textColor">
    <ion-col size="0.5">

    </ion-col>
    <ion-col *ngIf="!isActual" size="1" class="leftCol">
      {{unit | uppercase}}
    </ion-col>
    <ion-col *ngIf="isActual" size="2" class="leftCol">
      DISTANCE
    </ion-col>
    <ion-col size="1.5" class="midCol">
      PACE
    </ion-col>
    <ion-col [size]="isActual?4:5" class="midCol">

    </ion-col>

    <ion-col size="1.5" class="midCol">
      ELEV
    </ion-col>
    <ion-col size="1.5" class="midCol">
      HR
    </ion-col>
    <ion-col size="0.5">

    </ion-col>
  </ion-row>
  <ng-container *ngFor="let lap of laps, let i = index">
    <ion-row class="tableRow"  [style.color]="textColor+'BF'">
      <ion-col size="0.5">
      </ion-col>
      <ion-col *ngIf="!isActual" size="1" class="leftCol">
        <ng-container *ngIf="i<laps.length-1">
          {{i+1}}
        </ng-container>
        <ng-container *ngIf="i===laps.length-1">
          {{lap.distance/unitSize | number: '1.0-0'}}
        </ng-container>
        </ion-col>
        <ion-col *ngIf="isActual" size="2" class="rightCol">
          {{lap.distance | number: '1.0-0'}}
        </ion-col>
      <ion-col size="1.5" class="midCol">
        {{lap.pace | elapsed}}
      </ion-col>
      <ion-col [size]="isActual?4:5" class="midCol">
        <div class="bar" [style.background]="calcBar(lap,colors[i])"></div>
      </ion-col>

      <ion-col size="1.5" class="midCol" *ngIf="!isActual">
        {{lap.elevation_difference | number : '1.0-0'}}
      </ion-col>
      <ion-col size="1.5" class="midCol" *ngIf="isActual">
        {{lap.total_elevation_gain | number : '1.0-0'}}
      </ion-col>
      <ion-col size="1.5" class="midCol">
        {{lap.average_heartrate | number : '1.0-0'}}
      </ion-col>
      <ion-col size="0.5">

      </ion-col>
    </ion-row>
  </ng-container>
  <ion-row *ngIf="activity" class="tableRow"  [style.color]="textColor+'BF'" [style.fontWeight]="'bold'">
      <ion-col size="0.5">
      </ion-col>
      <ion-col *ngIf="isActual" size="2" class="rightCol">
        {{activity.distance | number: '1.0-0'}}
      </ion-col>
      <ion-col size="1.5" class="midCol">
        {{activity.pace | elapsed}}
      </ion-col>
      <ion-col [size]="isActual?4:5" class="midCol">
        <div class="bar"  [style.background]="calcBar(activity,colors[0] )"></div>
      </ion-col>

      <ion-col size="1.5" class="midCol" >
        {{activity.total_elevation_gain | number : '1.0-0'}}
      </ion-col>
      <ion-col size="1.5" class="midCol">
        {{activity.average_heartrate | number : '1.0-0'}}
      </ion-col>
      <ion-col size="0.5">

      </ion-col>
    </ion-row>
</ng-container>
